import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import DataTable from 'react-data-table-component';
import { withRouter } from 'react-router-dom';
import DemandeService from '../../service/DemandeService';
import EntiteService from '../../service/EntiteService';
import UserService from '../../service/UserService';
import Aside from '../espace_user/Aside';
import NavBarComponent from '../header/NavBarComponent';
import ConvertDate from './ConvertDate';
import DetailsDemande from './DetailsDemande';
import ModalChoix from './ModalChoix';
import ModalReply from './ModalReply';
import RetrieveBD from './RetrieveBD';
import RetrieveEntite from './RetrieveEntite';
import RetrieveMessage from './RetrieveMessage';
import HomeUserCSS from '../../css/espace_user/HomeUserCSS.css'

class ListeDemande extends Component {
    state = {
        demandesUser: [],
        utilisateur: this.props.match.params.id,
        allDemandesUser: [],
        idUser: localStorage.getItem('idUser'),
        addModalShow: false,
        addModalReplyhow: false,
        entite: null,
        bd: null,
        entite_bd: null,
        idUser: parseInt(localStorage.getItem('idUser')),
        user: '',
        demande: ''
    }
    componentDidMount() {
        const { idUser, allDemandesUser, demandesUser, utilisateur } = this.state
        UserService.getUserById(this.state.idUser).then((res) => {
            this.setState({
                user: res.data
            })

        }
        );
        if (utilisateur == -1) {
            DemandeService.getDemandeByType("requete").then((res => {
                this.setState({
                    allDemandesUser: res.data
                })

            }));
        } else {
            DemandeService.getDemandeByUserAndType(idUser, "requete").then((res => {
                this.setState({
                    allDemandesUser: res.data
                })

            }));
        }


    }
    closeModelChoix = () => {
        this.setState({
            addModalShow: false
        });

    }



    openModalDemande = () => {
        this.setState({
            addModalShow: true
        });

    }

    closeModelReply = () => {
        this.setState({
            addModalReplyhow: false
        });

    }



    openModalReply = (demande_) => {
        this.setState({
            demande: demande_,
            addModalReplyhow: true
        });

    }

    ViewDetail = (id) => {
        this.props.history.push(`/detailDemande/${id}`);

    }
    showAnswer = (demande) => {
        console.log(demande)
    }
    deleteDemande=(id)=>{
        DemandeService.deleteDemande(id).then((res) => {

            this.setState({
                allDemandesUser: this.state.allDemandesUser.filter(thematique => thematique.idDemande !== id),
                
            })

        })
    }

    render() {
        const { demandesUser } = this.state
        return (
            <div>
                <NavBarComponent />
                <div className='row col-lg-12'>

                    <Aside  active={1}/>
                    <div className='col-lg-10'>
                        <a className='btn div_demande_ ' >
                        <a href="#" onClick={this.openModalDemande}><span><bi className="bi  btn-add-thematique  bi-plus-circle-fill"><span className='ajout_theme'>Ajouter une demande</span> </bi></span></a>
                            
                        </a>
                        <div className="">
                            <table className="table-hover  table_dmd  table table-bordered table-striped">
                                <thead className="bg-light">
                                    <tr>
                                        <th>Date d'envoi</th>
                                        <th>Base de données</th>
                                        <th>Entite</th>
                                        <th className='msg_td_dmd'>Messsage</th>
                                        <th>Etat</th>
                                        <th><bi className="bi bi-three-dots" ></bi></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        this.state.allDemandesUser.map(
                                            demandes =>
                                            
                                                <tr key={demandes.idDemande}>
                                                   
                                                    <ConvertDate date={demandes.dateEnvoi} />
                                                    <RetrieveBD entite_bd={demandes.entite} />
                                                    <RetrieveEntite entite_bd={demandes.entite} />
                                                    <RetrieveMessage entite_bd={demandes.entite} />
                                                    {/* <td><bi className="bi bi-three-dots" ></bi></td>*/}
                                                    {(demandes.etat == 'non repondu') && (<td><bi className="bi bi-check2 etat_notreply"></bi></td>)}
                                                    {(demandes.etat !== 'non repondu') && (<td><bi className="bi bi-check2-all etat"></bi></td>)}

                                                    <td>
                                                        <button className="btn  btn-primary" onClick={() => this.ViewDetail(demandes.idDemande)}><bi className="bi bi-eye-fill"></bi></button>
                                                        {/*(this.state.user.profil == "visiteur") && (<button className="btn btn-info" style={{ marginLeft: "10px" }} onClick={() => this.deleteEmploye(demandes.idDemande)}><bi className="bi  bi bi-pencil-fill"></bi></button>)*/}
                                                        {(this.state.user.profil == "visiteur") && (<button className="btn btn-danger" style={{ marginLeft: "10px" }} onClick={() => this.deleteDemande(demandes.idDemande)}><bi className="bi  bi-trash-fill"></bi></button>)}
                                                        {(this.state.user.profil == "agent") && (<button onClick={() => this.openModalReply(demandes.idDemande)} key={demandes.idDemande} id={demandes.idDemande} className="btn btn-success" style={{ marginLeft: "10px" }}><bi className="bi  bi-reply-fill"></bi></button>)}
                                                    </td>
                                                    
                                                </tr>
                                               
                                        )
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <ModalChoix
                        show={this.state.addModalShow}
                        closeModelChoix={this.closeModelChoix}


                    />
                    <ModalReply
                        show={this.state.addModalReplyhow}
                        closeModelReply={this.closeModelReply}
                        demande={this.state.demande}
                        id={this.state.demande}

                    />



                </div>
            </div>
        );
    }
}

export default withRouter(ListeDemande);